import React from 'react';

import { Button } from '@betterment/samba-react';

import { useImpersonationModal } from '../../contexts/ImpersonationModalContext';
import FormButton from '../FormButton';

export type ImpersonationLinkProps = {
  showModal: boolean;
  url: string;
  label: string;
  css?: React.ComponentProps<typeof Button>['css'];
  variant?: 'textPrimary' | 'textSecondary' | 'solidPrimary';
};

export const ImpersonationLink: React.FC<ImpersonationLinkProps> = ({
  showModal,
  url,
  label,
  css: cssProp,
  variant = 'textSecondary',
}) => {
  const { openModal: openImpersonationModal } = useImpersonationModal();

  if (showModal) {
    return (
      <Button
        css={{
          textDecoration: 'none',
          ...cssProp,
        }}
        onClick={() => {
          openImpersonationModal(url);
        }}
        variant={variant}
      >
        {label}
      </Button>
    );
  }

  return (
    <FormButton
      method="post"
      action={url}
      shouldOpenNewTab={true}
      variant={variant}
      css={{
        textDecoration: 'none',
        ...cssProp,
      }}
    >
      {label}
    </FormButton>
  );
};
